import { render } from "./OutgoingGoodsClientModal.vue?vue&type=template&id=0fa70be4"
import script from "./OutgoingGoodsClientModal.vue?vue&type=script&lang=js"
export * from "./OutgoingGoodsClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__